import { RefinementCtx, ZodIssueCode, string } from "zod";

import { INVALID_MILEAGE_MESSAGE } from "./validationMessages";

const mileageInputValidationSchema = string().transform(
    (value: string, ctx: RefinementCtx): string => {
        if (!value) {
            ctx.addIssue({
                code: ZodIssueCode.custom,
                message: INVALID_MILEAGE_MESSAGE,
            });
        }

        const parsedValue = parseInt(value);
        if (isNaN(parsedValue)) {
            ctx.addIssue({
                code: ZodIssueCode.custom,
                message: INVALID_MILEAGE_MESSAGE,
            });
        } else if (parsedValue < 0 || parsedValue > 500000) {
            ctx.addIssue({
                code: ZodIssueCode.custom,
                message: INVALID_MILEAGE_MESSAGE,
            });
        }

        return value;
    }
);

export default mileageInputValidationSchema;
